module.exports = __webpack_public_path__ + "static/media/torreLogo.4d708c2a.png";